(function () {
    'use strict';

    angular
        .module('app')
        .factory('ExternalService', ExternalService);


    function ExternalService($http, $q, $rootScope, WebAPIUrl) {

        var service = {

            UpdateCPData: UpdateCPData

        };

 
        return service;

       
        function UpdateCPData(log) {
            var deferred = $q.defer();

            $http({
                method: 'GET',
                url: WebAPIUrl + '/api/external/UpdateCPData?log=' + log
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);

            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;
        }

      


    }

})();